module.exports = __webpack_public_path__ + "img/seo-reporter.58897643.webp";